import { render, staticRenderFns } from "./sfzForm.vue?vue&type=template&id=51ed93a9&"
import script from "./sfzForm.vue?vue&type=script&lang=js&"
export * from "./sfzForm.vue?vue&type=script&lang=js&"
import style0 from "./sfzForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports